import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41603290"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "MCapacidadeValor",
  "data-testid": "MCapacidadeValor"
}
const _hoisted_2 = {
  key: 0,
  class: "MCapacidadeValor__Valores"
}
const _hoisted_3 = { class: "MCapacidadeValor__Horas" }

import Chip from "primevue/chip"
  import OHoras from "../OHoras/OHoras.vue"
  import { MapPeriodoDeConsumoRotulo } from "./OCapacidadeValor.interface"
  import { ChavePeriodoDeConsumo } from "@/types/capacidades"
  import { CapacidadesStore } from "@/store/atributos/capacidades/capacidades.store"
  import { storeToRefs } from "pinia"
  import { TiposPossiveis } from "@/types/atributo"
  import { computed, withDefaults } from "vue"
  import { useI18n } from "vue-i18n"

  interface Props {
    indice: number
    nome?: string
    tipoDeValor?: TiposPossiveis
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OCapacidadeValor',
  props: {
    indice: { default: 0 },
    nome: null,
    tipoDeValor: null
  },
  setup(__props: any) {

const props = __props as { indice: number, nome?: string, tipoDeValor?: TiposPossiveis }

  

  const { t } = useI18n()

  const capacidadesStore = CapacidadesStore()
  const { capacidades } = storeToRefs(capacidadesStore)

  const aoMesmoTempoDesativado = computed(() => {
    return (periodo: ChavePeriodoDeConsumo) =>
      props.tipoDeValor === "quantidade_de_horas" && periodo === "aoMesmoTempo"
  })

  const acharRotuloParaPeriodoDeConsumo = (chave: ChavePeriodoDeConsumo) => {
    if (!chave) {
      throw new Error(t("chaveDePeriodoDeConsumoIndefinida"))
    }
    return MapPeriodoDeConsumoRotulo[chave]
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Chip), {
      class: "MCapacidadeValor__Chip",
      label: __props.nome
    }, null, 8, ["label"]),
    (_unref(capacidades).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(capacidades)[__props.indice]
          .periodosDeConsumo, (_, chavePeriodoDeConsumo) => {
            return (_openBlock(), _createElementBlock("div", {
              key: chavePeriodoDeConsumo,
              class: "MCapacidadeValor__PeriodoConsumo"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(OHoras, {
                  modelValue: 
              _unref(capacidades)[__props.indice].periodosDeConsumo[chavePeriodoDeConsumo]
            ,
                  "onUpdate:modelValue": ($event: any) => ((
              _unref(capacidades)[__props.indice].periodosDeConsumo[chavePeriodoDeConsumo]
            ) = $event),
                  class: "MCapacidadeValor__Valor",
                  desativado: _unref(aoMesmoTempoDesativado)(chavePeriodoDeConsumo)
                }, null, 8, ["modelValue", "onUpdate:modelValue", "desativado"])
              ]),
              _createElementVNode("span", null, _toDisplayString(acharRotuloParaPeriodoDeConsumo(chavePeriodoDeConsumo)), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})